import { BlockFactory } from '@application/lib/core';

import { node } from 'core/node';
import { Node } from '@types';

export const blankTemplate: Node = node(BlockFactory.initializeBlock('container'));
